import styled from 'styled-components';

export const VideoStoriesContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  max-width: 100%;
  overflow: hidden;
`;

export const InstagramStory = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 9/16;
  background: black;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  .floating-heart {
    position: absolute;
    bottom: 16px;
    transform: translateX(-50%);
    pointer-events: none;
    user-select: none;
    opacity: 0.9;
    animation: float-up 2.8s ease-out forwards;
  }

  @keyframes float-up {
    0% {
      transform: translate(-50%, 0) scale(0.8);
      opacity: 0.9;
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -180px) scale(1.1);
      opacity: 0;
    }
  }
`;

export const StoryProgressBar = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  z-index: 10;
`;

export const ProgressSegmentContainer = styled.div`
  flex: 1;
  height: 3px;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
`;

export const ProgressSegmentBg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
`;

export const ProgressSegmentFill = styled.div`
  position: absolute;
  height: 100%;
  background: white;
  transition: width 0.1s linear;
`;

export const StoryHeader = styled.div`
  position: absolute;
  top: 20px;
  left: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
`;

export const StoryHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StoryUserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StoryTime = styled.span`
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  font-weight: normal;
`;

export const StoryHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StoryControlButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const StoryVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StoryActions = styled.div`
  position: absolute;
  bottom: 24px;
  right: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  z-index: 10;
`;

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

export const TestimonialName = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin: 0;
`;

export const InstagramActionButton = styled.button<{ liked?: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  ${(props) =>
    props.liked &&
    `
    animation: heartBeat 0.6s ease-in-out;

    @keyframes heartBeat {
      0%, 100% { transform: scale(1); }
      25% { transform: scale(1.3); }
      50% { transform: scale(1.1); }
      75% { transform: scale(1.25); }
    }
  `}
`;
